import { fromJS, Map } from 'immutable';
import { COMMIT_SEARCH_PARAMS } from '../constants/searchParams';
import { SET_FROM_SEARCH_OFFER } from '../constants/searchOffer';

const initialState = Map();

export default function (state = initialState, action) {
  switch (action.type) {
    case COMMIT_SEARCH_PARAMS: {
      return initialState;
    }
    case SET_FROM_SEARCH_OFFER: {
      return state.set('from_city', fromJS(action.payload));
    }
    default:
      return state;
  }
}
